import { window } from '../window.js';
import { HTMLControl } from './html_control.js';

/**
 * The list of images.
 **/
class ImageList extends HTMLControl {
  get selectedIndex() {
    return (this.selectedItemElement && this.selectedItemElement.index) || -1;
  }

  get selectedItem() {
    return this.selectedItemElement;
  }

  set(list) {
    this.innerHTML = list
      .map(
        src =>
          `<image-list-item class='image-item' src='${src}'></image-list-item>`
      )
      .join('');
  }

  static get selectors() {
    const AllItems = 'image-list-item';
    return {
      AllItems,
      SelectedItem: `${AllItems}[selected]`,
      ItemAt(index) {
        return `${AllItems}:nth-of-type(${index + 1})`;
      },
    };
  }
}

window.customElements.define('image-list', ImageList);

/**
 * Item of image-list control.
 */
class ImageListItem extends HTMLControl {
  static properties = {
    src: {
      attribute: true,
      set(v) {
        this.imageElement.src = v;
      },
    },
  };

  get index() {
    let index = 0;
    for (
      let el = this.previousElementSibling;
      el;
      el = el.previousElementSibling
    ) {
      if (el.localName == this.localName) {
        index++;
      }
    }
    return index;
  }

  constructor() {
    super();
    this.addEventListener('click', ev => this.onClick(ev));
  }

  static get markup() {
    return `<div class='ratio-box'><img class='image'></div>`;
  }

  onClick() {
    let selectedEl = this.parentNode.selectedItemElement;
    if (selectedEl) {
      selectedEl.removeAttribute('selected');
    }
    this.setAttribute('selected', 'true');
    this.parentNode.dispatchEvent(
      new CustomEvent('itemselect', {
        detail: this,
      })
    );
  }

  static selectors = {
    Image: 'img.image',
  };

  static elements = {
    imageElement: this.selectors.Image,
  };
}

window.customElements.define('image-list-item', ImageListItem);

export { ImageList, ImageListItem };
